import React, { PureComponent } from 'react';
import { getBackendBoolean } from '@Sage/ssm-utils/backendScalars';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { EntityCrudActions } from 'actions';
import { COMPANIES } from 'constants/Entities';
import Context from 'managers/Context';
import LoaderHoi from 'components/LoaderHoi';
import Select from 'containers/components/Fields/Select';
import { getFieldWorkFlow, dependantOptionsFilter } from 'utils/fm';
import { logEvent } from 'utils/tracking';
import { getActiveCrud } from 'utils/crud';

import './styles.scss';

function mapStateToProps(state, ownProps) {
    let entityCrud = getActiveCrud(state);
    let entityDetail = state.entityDetail[state.entityDetail.active] || {};
    let detailData = entityDetail.data;
    let standardFieldsSchemaMap = (state.config && state.config.standardFieldsSchemaMap) || {};

    const stateCompanyReadOnly =
        standardFieldsSchemaMap &&
        standardFieldsSchemaMap[COMPANIES.extraFieldName] &&
        standardFieldsSchemaMap[COMPANIES.extraFieldName]['idestadoempresa'] &&
        standardFieldsSchemaMap[COMPANIES.extraFieldName]['idestadoempresa'].readOnly;

    const dependencyParentField =
        standardFieldsSchemaMap[COMPANIES.extraFieldName] &&
        standardFieldsSchemaMap[COMPANIES.extraFieldName]['idestadoempresa'] &&
        standardFieldsSchemaMap[COMPANIES.extraFieldName]['idestadoempresa'].strParentField;
    const workFlowPermissions = state.config.userData.workFlows;
    const workFlowPermission =
        workFlowPermissions &&
        workFlowPermissions[entityCrud.entity] &&
        workFlowPermissions[entityCrud.entity] === '1';

    return {
        loadingSave: entityCrud.loadingSave,
        workFlow:
            (workFlowPermission &&
                state.config.workFlows &&
                state.config.workFlows[COMPANIES.workFlow]) ||
            null,
        idUserType: state.config.userData.idTipoUsuario,
        detailData,
        dependencyParentField,
        crudSchema: entityCrud.schema,
        stateCompanyReadOnly,
        isEntityReadOnly: (detailData && getBackendBoolean(detailData.readOnlyCompany)) || false,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        changeFields: bindActionCreators(EntityCrudActions, dispatch).changeFields,
        save: bindActionCreators(EntityCrudActions, dispatch).save,
    };
}

class CompanyStatusSelector extends PureComponent {
    state = {
        loading: false,
    };

    onChange = (value) => {
        const { changeFields, save } = this.props;
        const data = { idCompanyState: value };
        this.setState({ loading: true });
        changeFields(data)
            .then(() => {
                return save({
                    entity: COMPANIES,
                    openDetail: true,
                    hasCrudInDetail: true,
                    fieldsToUpdate: data,
                    fromWorkFlow: false,
                });
            })
            .then(() => {
                this.setState({ loading: false });
            })
            .catch(() => {
                this.setState({ loading: false });
            });
        logEvent({
            event: COMPANIES.trueName,
            functionality: 'update',
        });
    };

    beforeRenderValueList = (options) => {
        const { dependencyParentField, crudSchema, detailData } = this.props;
        if (!options) return [];
        if (!dependencyParentField || !crudSchema || crudSchema.length === 0) return options;

        let dependantField;
        crudSchema.forEach((tab) => {
            tab.fields?.forEach((field) => {
                if (
                    field.fieldConfiguration &&
                    field.fieldConfiguration === dependencyParentField
                ) {
                    dependantField = field;
                }
            });
        });

        if (!dependantField) return options;

        const dependantValue = detailData?.[dependantField.id];
        return dependantOptionsFilter(options, dependantValue);
    };

    render() {
        const {
            detailData,
            workFlow,
            idUserType,
            stateCompanyReadOnly,
            isEntityReadOnly,
            isReadOnly,
        } = this.props;
        const { loading } = this.state;
        const manager = Context.entityManager.getEntitiesManager(COMPANIES);
        const fieldWorkFlow = getFieldWorkFlow('idestadoempresa', workFlow, idUserType);
        const isFieldReadOnly = isReadOnly || stateCompanyReadOnly || isEntityReadOnly;

        return (
            <div className="company-status-selector">
                {loading ? (
                    <div className="company-status-selector__loading" aria-live="polite">
                        <LoaderHoi type="tiny" />
                    </div>
                ) : (
                    <Select
                        list="tblEstadosEmpresa"
                        onChange={this.onChange}
                        value={detailData?.idCompanyState}
                        isClearable={false}
                        isFullWidth
                        groupFunction={manager?.groupStates}
                        getExtraClassNameValue={manager?.getExtraClassNameStateValue}
                        workFlow={fieldWorkFlow}
                        readOnly={isFieldReadOnly}
                        beforeRenderValueList={this.beforeRenderValueList}
                    />
                )}
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyStatusSelector);
